module.exports = __webpack_public_path__ + "img/x3.862d5ed4.jpg";